import { lazy } from 'react'

type LazyRouteFactory = Parameters<typeof lazy>[0]

const CHUNK_RELOAD_FLAG = 'cc.chunk-reload'

const MODULE_LOAD_ERROR = /dynamically imported module|Importing a module script failed|MIME type|ChunkLoadError|Loading chunk \d+ failed/i

function isStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error)
  return MODULE_LOAD_ERROR.test(message)
}

function alreadyReloaded(): boolean {
  try {
    return sessionStorage.getItem(CHUNK_RELOAD_FLAG) !== null
  } catch {
    return true
  }
}

function rememberReload(): void {
  try {
    sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1')
  } catch {
    return
  }
}

function forgetReload(): void {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_FLAG)
  } catch {
    return
  }
}

export function lazyRoute(load: LazyRouteFactory): ReturnType<typeof lazy> {
  return lazy(async () => {
    try {
      const routeModule = await load()
      forgetReload()
      return routeModule
    } catch (error) {
      if (!isStaleChunkError(error) || alreadyReloaded()) throw error
      rememberReload()
      window.location.reload()
      return await new Promise<never>(() => {})
    }
  })
}
